import {
  Form,
  SaveButton,
  useDataProvider,
  useNotify,
  useRefresh,
  useTranslate,
  UpdateParams,
  CreateContextProvider,
  useCreateController,
} from 'react-admin';
import { DialogTitle, DialogContent, DialogActions, Button as MUIButton } from '@mui/material';
import SetUnlimitedForm from './SetUnlimitedForm';
import { Resources } from '../resource';
import { PermissionButton } from 'src/routes/components/permission-button';

type UnlimitedAgent = {
  id: string;
  userId: string;
  commissionRateN: number;
  status: 'ACTIVE' | 'INACTIVE';
};

type Row = {
  userId: string;
  infiniteAgentConfig?: { commissionRateN?: number; status?: 'ACTIVE' | 'INACTIVE' };
};

export const SetUnlimitedLevel = ({
  row,
  open,
  onClose,
}: {
  row: Row;
  open?: boolean;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const controller = useCreateController({
    resource: Resources.unlimitedAgents,
    mutationOptions: {
      onSuccess: () => {
        notify('module.agentInfo.setToUnlimitedAgentSuccess', { type: 'success' });
        refresh();
        onClose();
      },
      onError: (error: any) => {
        const msg = t(error?.body?.message) || t(error?.message) || 'module.agentInfo.unknownError';
        notify(msg, { type: 'warning' });
      },
    },
  });


  return (
    <CreateContextProvider value={controller}>
      <Form
        defaultValues={{
          userId: row.userId,
          commissionRateN: row.infiniteAgentConfig?.commissionRateN ?? 0,
          status: row.infiniteAgentConfig?.status ? 'ACTIVE' : 'INACTIVE',
        }}
        disableInvalidFormNotification
      >
        <DialogTitle>{t('module.agentInfo.SetAgentToUnlimited')}</DialogTitle>
        <DialogContent>
          <SetUnlimitedForm isCreate />
        </DialogContent>
        <DialogActions>
          <MUIButton variant="outlined" onClick={onClose}>
            {t('actions.cancel')}
          </MUIButton>
          <PermissionButton resource="unlimited-agents" action="create">
            <SaveButton />
          </PermissionButton>
        </DialogActions>
      </Form>
    </CreateContextProvider>
  );
};

export default SetUnlimitedLevel;
